import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Users, ClipboardList, Tag } from "lucide-react";
import { fetchConfig, fetchDefaultPlays } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppHeader, PageShell } from "@/components/AppHeader";
import { Segmented } from "@/components/controls/Segmented";
import { PlaybookView } from "@/components/PlaybookView";

const SPORTS = [
  { value: "baseball", label: "Baseball" },
  { value: "softball", label: "Softball" },
];

export default function FieldPage() {
  const [config, setConfig] = useState(null);
  const [sport, setSport] = useState("baseball");
  const [level, setLevel] = useState("ll");
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { fetchConfig().then(setConfig); }, []);
  const loadPlays = useCallback((s) => fetchDefaultPlays(sport, level, s), [sport, level]);

  if (!config) return <div className="min-h-screen grid place-items-center font-heading text-2xl">Loading field...</div>;
  const levels = Object.entries(config.sports[sport]);
  const changeSport = (s) => {
    if (s === "softball" && !user?.access?.has_access) {
      toast("Softball is part of the Team plan. Start your free 14-day trial.");
      navigate(user ? "/pricing" : "/login");
      return;
    }
    setSport(s);
    setLevel(Object.keys(config.sports[s])[0]);
  };

  return (
    <PageShell>
      <AppHeader>
        <Segmented options={SPORTS} value={sport} onChange={changeSport} testPrefix="sport-toggle" />
        {levels.length > 1 && (
          <select data-testid="level-select" className="level-select" value={level} onChange={(e) => setLevel(e.target.value)}>
            {levels.map(([id, l]) => <option key={id} value={id}>{l.name}</option>)}
          </select>
        )}
        <Link to="/pricing" className="nav-btn" data-testid="nav-pricing-link"><Tag size={18} /> <span className="hidden sm:inline">Pricing</span></Link>
        <Link to="/join" className="nav-btn" data-testid="nav-join-link"><Users size={18} /> <span className="hidden sm:inline">Join team</span></Link>
        <Link to={user ? "/coach" : "/login"} className="nav-btn" data-testid="nav-coach-link"><ClipboardList size={18} /> <span className="hidden sm:inline">{user ? "My teams" : "Coach"}</span></Link>
      </AppHeader>
      <PlaybookView cfg={config.sports[sport][level]} loadPlays={loadPlays} />
    </PageShell>
  );
}
